import { reactive, ref } from '@vue/composition-api';
import { debounce } from 'lodash';

export let windowSize = reactive({
  width: window.innerWidth,
  height: window.innerHeight,
});

let onResize = function(e) {
  windowSize.height = window.innerHeight;
  windowSize.width = window.innerWidth;
};

window.addEventListener('resize', debounce(onResize, 500));

export const useWindow = function() {
  return { windowSize };
};
